var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 1C19.6278 1 25 6.373 25 13C25 19.6271 19.6278 25 13 25C6.37218 25 1 19.627 1 13C1 6.37308 6.37225 1 13 1Z",
    fill: "white",
    stroke: "#1C6947",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1241 8.99883C10.1241 9.61983 9.62011 10.1238 8.99906 10.1238C8.37805 10.1238 7.87402 9.61991 7.87402 8.99891C7.87402 8.3779 8.37805 7.87387 8.99906 7.87387C9.62011 7.87387 10.1241 8.37782 10.1241 8.99883ZM16.6395 10.6127C15.5489 10.6127 14.5732 11.011 13.881 11.89V10.8476H11.6257V18.3618H13.881V14.2983C13.881 13.4395 14.6678 12.6017 15.6532 12.6017C16.6387 12.6017 16.8818 13.4395 16.8818 14.2773V18.361H19.1288V14.11C19.1287 11.1573 17.7307 10.6127 16.6395 10.6127ZM7.88574 18.3601H10.1327V10.8705H7.88574V18.3601Z",
    fill: "#1C6947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "res/media/linkedin.9b32d9b9c958383313fd1f6e1d16629c.svg";
export { ForwardRef as ReactComponent };